import React from 'react';

import { ButtonLink } from '@toggle/design-system';

import styles from './DrawerSectionFooter.module.scss';

type DrawerSectionFooterProps = {
  label: string;
  onClick: () => void;
};

export const DrawerSectionFooter = ({
  label,
  onClick,
}: DrawerSectionFooterProps) => (
  <ButtonLink
    className={styles.buttonLink}
    label={label}
    iconName={'ChevronLightRight'}
    iconPosition="right"
    onClick={onClick}
  />
);
